import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Portfolio from "@/pages/Portfolio";
import Tracker from "@/pages/Tracker";
import TrackedDetail from "@/pages/TrackedDetail";
import Comparativo from "@/pages/Comparativo";
import Players from "@/pages/Players";
import SettingsPage from "@/pages/Settings";
import Diagnostico from "@/pages/Diagnostico";

function App() {
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    remove();
    const id = setInterval(remove, 500);
    return () => clearInterval(id);
  }, []);

  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppShell><Dashboard /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/portfolio"
              element={
                <ProtectedRoute>
                  <AppShell><Portfolio /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/rastrear"
              element={
                <ProtectedRoute>
                  <AppShell><Tracker /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/rastrear/:id"
              element={
                <ProtectedRoute>
                  <AppShell><TrackedDetail /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/comparativo"
              element={
                <ProtectedRoute>
                  <AppShell><Comparativo /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/players"
              element={
                <ProtectedRoute>
                  <AppShell><Players /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configuracoes"
              element={
                <ProtectedRoute>
                  <AppShell><SettingsPage /></AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/diagnostico"
              element={
                <ProtectedRoute>
                  <AppShell><Diagnostico /></AppShell>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0a1c15",
                color: "#f4f7f5",
                border: "1px solid #183d2d",
                borderRadius: "2px",
              },
            }}
          />
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
